import { Component, computed, contentChildren, input, output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { PnIcon } from '@privanot/shared-ui/common/icon';
import { PnToastPosition, PnToastCloseEvent } from './interfaces/toast.interfaces';
import { PnToastTemplate } from './directives/pn-toast-template.directive';

@Component({
    selector: 'pn-toast',
    imports: [ToastModule, NgTemplateOutlet, PnIcon],
    templateUrl: './toast.html',
    styleUrl: './toast.scss',
})
export class PnToast {
    position = input<PnToastPosition>('top-right');
    life = input<number>(3000);
    key = input<string>();
    preventDuplicates = input(false);
    breakpoints = input<Record<string, Record<string, string>>>();

    closed = output<PnToastCloseEvent>();

    // Templates
    private templates = contentChildren(PnToastTemplate);
    protected messageTemplate = computed(() => this.findTemplate('message'));
    protected headlessTemplate = computed(() => this.findTemplate('headless'));

    protected onClose(event: { message: unknown }): void {
        this.closed.emit({ message: event.message as PnToastCloseEvent['message'] });
    }

    private findTemplate(name: string): TemplateRef<unknown> | undefined {
        return this.templates().find((t) => t.name() === name)?.templateRef;
    }
}
